export function formatToCroatianDate(dateString: string): string {
  let date: Date | null = null;

  // Regex for Croatian format dd.mm.yyyy
  const croatianDateRegex = /^(\d{2})\.(\d{2})\.(\d{4})$/;
  // Regex for US format mm/dd/yyyy or mm/dd/yy
  const usDateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/;

  let match;

  if ((match = dateString.match(croatianDateRegex))) {
    // Croatian format dd.mm.yyyy
    const day = Number(match[1]);
    const month = Number(match[2]) - 1;
    const year = Number(match[3]);
    date = new Date(year, month, day);
  } else if ((match = dateString.match(usDateRegex))) {
    // US format mm/dd/yyyy or mm/dd/yy
    const month = Number(match[1]) - 1;
    const day = Number(match[2]);
    let year = Number(match[3]);

    // If year is 2-digit, convert to 4-digit (assume 2000+)
    if (year < 100) {
      year += 2000;
    }

    date = new Date(year, month, day);
  } else {
    // fallback to default Date parsing
    date = new Date(dateString);
  }

  if (isNaN(date.getTime())) {
    return '';
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}.`;
}
